import { render, staticRenderFns } from "./FormMask.vue?vue&type=template&id=40574df2"
import script from "./FormMask.vue?vue&type=script&lang=js"
export * from "./FormMask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports